export const TYPE_ACCEPT = {
    PNG: "image/png",
    JPEG: "image/jpeg",
    PDF: "application/pdf"
}

export const LIST_ACCEPT = [
    TYPE_ACCEPT.PNG,
    TYPE_ACCEPT.JPEG,
    TYPE_ACCEPT.PDF,
]

export const LIST_ACCEPTNOTPDF = [
    TYPE_ACCEPT.PNG,
    TYPE_ACCEPT.JPEG,
]

export const MODE = {
    VIEW: 'view',
    EDIT: 'edit',
}

export const attachmentList = [
    {
        title: 'รูปถ่าย',
        docType: 'photo'
    },
    {
        title: 'ประวัติการทำงาน (Resume)',
        docType: 'cv'
    },
    {
        title: 'สำเนาบัตรประจำตัวประชาชน ที่ยังไม่หมดอายุ',
        docType: 'idCardCopy'
    },
    {
        title: 'สำเนาทะเบียนบ้าน',
        docType: 'houseRegisCopy'
    },
    {
        title: 'สำเนาปริญญาบัตร หรือสำเนาประกาศนียบัตรที่แสดงว่าเป็นผู้มีคุณวุฒิศึกษาตรงตามประกาศรับสมัคร หรือหนังสือรับรองจากสภามหาวิทยาลัย',
        docType: 'diploma'
    },
    {
        title: 'สำเนาใบแสดงผลการศึกษา (Transcript of Records) หรือสำเนาระเบียนแสดงผลการเรียน',
        docType: 'transcriptCopy'
    },
    {
        title: 'อื่นๆ',
        docType: 'other'
    },
]

export const progressSteps = [
    {
        title: 'ข้อมูลส่วนตัว',
    },
    {
        title: 'ข้อมูลการติดต่อ',
    },
    {
        title: 'ประวัติการศึกษา',
    },
    {
        title: 'ประสบการณ์การทำงาน',
    },
    {
        title: 'ความสามารถ',
    },
    {
        title: 'บุคคลอ้างอิง',
    },
    {
        title: 'เอกสารแบบ',
    },
    {
        title: 'ประวัติดำเนินคดี',
    },
    {
        title: 'ข่าวสารการรับสมัคร',
    },
    {
        title: 'ข้อตกลง',
    },
]

export const filterIsDeleted = (item) => {
    return item.isDeleted === false && item.isInactive === false
}